export type TTheme =
  | 'theme-base-bg'
  | 'theme-neutral-bg'
  | 'theme-accent-bg'
  | 'theme-dark-accent-bg'
  | 'theme-light-bg-img'
  | 'theme-dark-bg-img';

export enum SectionTheme {
  DARK,
  LIGHT,
}

export enum ETheme {
  BASE = 'theme-base-bg',
  NEUTRAL = 'theme-neutral-bg',
  ACCENT = 'theme-accent-bg',
  DARKACCENT = 'theme-dark-accent-bg',
  LIGHTIMAGE = 'theme-light-bg-img',
  DARKIMAGE = 'theme-dark-bg-img',
}
